import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Input,
  Icon
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardAffiliateSettingsUX = (props: any) => {
    return(
      <div
        id="CardAffiliateSettingsUX-div-0"
        style={{ margin: "10px", height: "100%" }}>
        <div
          id="CardAffiliateSettingsUX-div-1"
          style={{ padding: "10px 20px 0px", background: "#faf4f6",  borderRadius: "7px", border: "1px solid #dcd0d4" }}>
          
          <Form
            id="CardAffiliateSettingsUX-Form-2">
            <FormGroup
              id="CardAffiliateSettingsUX-FormGroup-3">
              <FormField
                id="CardAffiliateSettingsUX-FormField-4"
                width="4">
                <label
                  id="CardAffiliateSettingsUX-label-9">
                  เลือก Affiliate เพื่อจัดการสิทธิขายสินค้า
                </label>
                <div
                  id="CardAffiliateSettingsUX-div-34">
                  {props.searchAffiliateGroup}
                </div>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-5"
                width="3">
                <label
                  id="CardAffiliateSettingsUX-label-10">
                  Tier (ระดับ)
                </label>
                <Dropdown
                  id="CardAffiliateSettingsUX-Dropdown-15"
                  name="tierAffiliate"
                  onChange={props.onChangeData}
                  options={props.affiliateGroupListViewOption}
                  selection={true}
                  value={props.filterAffiliate?.tierAffiliate}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-6"
                style={{ flex: 1 }}>
                <label
                  id="CardAffiliateSettingsUX-label-11">
                  
                </label>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-7">
                <label
                  id="CardAffiliateSettingsUX-label-12">
                  {"\u00a0"}
                </label>
                <Button
                  id="CardAffiliateSettingsUX-Button-16"
                  onClick={props.buttonOpenModalDate}
                  style={{ background: "#fff" }}>
                  
                  <div
                    id="CardAffiliateSettingsUX-div-28"
                    style={{display: "flex", alignItems: "center"}}>
                    
                    <Icon
                      id="CardAffiliateSettingsUX-Icon-29"
                      name="calendar outline">
                    </Icon>
                    <label
                      id="CardAffiliateSettingsUX-label-30">
                      ตั้งวันที่ทั้งหมด
                    </label>
                  </div>
                </Button>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-8">
                <label
                  id="CardAffiliateSettingsUX-label-13">
                  {"\u00a0"}
                </label>
                <div>
                  {props.buttonSave}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardAffiliateSettingsUX-div-18">
          
          <Form
            id="CardAffiliateSettingsUX-Form-19">
            <FormGroup
              id="CardAffiliateSettingsUX-FormGroup-20"
              style={{ display: "flex", alignItems: "center", margin: "10px 0px" }}>
              <FormField
                id="CardAffiliateSettingsUX-FormField-21">
                <label
                  id="CardAffiliateSettingsUX-label-24">
                  {`รายการสินค้าทั้งหมดในระบบ (${ props.affiliateProductLength || 0 } รายการ)`}
                </label>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-22"
                style={{ flex: 1}}>
              </FormField>
              <FormField
                id="CardAffiliateSettingsUX-FormField-23"
                width={4}>
                <Input
                  icon="search"
                  id="CardAffiliateSettingsUX-Input-25"
                  name="searchProduct"
                  onChange={props.onChangeData}
                  placeholder="ค้นหารหัส หรือชื่อสินค้าในตาราง..."
                  value={props.filterAffiliate?.searchProduct}>
                </Input>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardAffiliateSettingsUX-div-26">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.affiliateProductData}
            getTdProps={props.getTdPropAaffiliateProductData}
            headers="รหัสสินค้า,ซื้อสินค้า,วันที่และเวลาเริ่ม,วันที่และเวลาสิ้นสุด,เปิดขาย"
            id="CardAffiliateSettingsUX-Table-27"
            keys="productCode,productName,startedAt,endedAt,activeProduct"
            showPagination={false}
            style={{ height: "calc(100vh - 16.5rem)"}}
            widths="120,*,270,270,100">
          </Table>
        </div>
      </div>
    )
}


export default CardAffiliateSettingsUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 17 2026 16:32:28 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 20px 0px\", background: \"#faf4f6\",  borderRadius: \"7px\", border: \"1px solid #dcd0d4\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Affiliate เพื่อจัดการสิทธิขายสินค้า"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Tier (ระดับ)"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "clearable": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Dropdown-15"
        },
        "name": {
          "type": "value",
          "value": "tierAffiliate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.affiliateGroupListViewOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterAffiliate?.tierAffiliate"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Button-16"
        },
        "onClick": {
          "type": "code",
          "value": "props.buttonOpenModalDate"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#fff\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-18"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Form",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Form-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormGroup-20"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"10px 0px\" }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-22"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-FormField-23"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "`รายการสินค้าทั้งหมดในระบบ (${ props.affiliateProductLength || 0 } รายการ)`"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Input",
      "parent": 23,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Input-25"
        },
        "name": {
          "type": "value",
          "value": "searchProduct"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหารหัส หรือชื่อสินค้าในตาราง..."
        },
        "value": {
          "type": "code",
          "value": "props.filterAffiliate?.searchProduct"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-26"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 27,
      "name": "Table",
      "parent": 26,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.affiliateProductData"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdPropAaffiliateProductData"
        },
        "headers": {
          "type": "value",
          "value": "รหัสสินค้า,ซื้อสินค้า,วันที่และเวลาเริ่ม,วันที่และเวลาสิ้นสุด,เปิดขาย"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Table-27"
        },
        "keys": {
          "type": "value",
          "value": "productCode,productName,startedAt,endedAt,activeProduct"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(100vh - 16.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "120,*,270,270,100"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Icon",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-Icon-29"
        },
        "name": {
          "type": "value",
          "value": "calendar outline"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งวันที่ทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchAffiliateGroup"
        },
        "id": {
          "type": "value",
          "value": "CardAffiliateSettingsUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardAffiliateSettingsUX",
  "project": "",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
